export const validateABNorACN = (value: string): 'ABN' | 'ACN' | 'invalid' => {
  const digits = value.replace(/\s+/g, '');
  if (/^\d{11}$/.test(digits)) return 'ABN';
  if (/^\d{9}$/.test(digits)) return 'ACN';
  return 'invalid';
};

export const isValidABN = (abn: string): boolean => {
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  const digits = abn.replace(/\s+/g, '').split('').map(Number);
  if (digits.length !== 11) return false;
  digits[0] = digits[0] - 1;
  const total = digits.reduce((sum, d, i) => sum + d * weights[i], 0);
  return total % 89 === 0;
};
